import React, { useEffect, useState, Fragment, useContext } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner'
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import axios from 'axios';
import swal from 'sweetalert';
import { getApiUrl, axiosPost, getDecodedCookie, getOptionsCboHelper } from '../../../helpers/helperApp';
import { alertService } from '../../../services/alertservice';
import Firma from '../Firma';
import { LoginContext } from '../../../hooks/context/LoginContext';

// CSS
// import 'datatables.net-dt/css/jquery.dataTables.css';
// import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
// import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';

// JS
import 'datatables.net';              // DataTables core
import 'datatables.net-dt';           // DataTables base para estilo DT
import 'datatables.net-bs4';          // Integración con Bootstrap 4
import 'datatables.net-buttons';      // Buttons core
import 'datatables.net-buttons-bs4';  // Buttons para Bootstrap 4
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';       // Select (debe ir después de DataTables)
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';   // Responsive core

// require('datatables.net-dt');
// require('datatables.net-responsive');
// require('datatables.net-buttons');
// require('datatables.net-bs4');

// require('datatables.net/js/jquery.dataTables');
// require('datatables.net-buttons/js/dataTables.buttons');
// require('datatables.net-buttons/js/buttons.colVis');
// require('datatables.net-buttons/js/buttons.flash');
// require('datatables.net-buttons/js/buttons.html5');
// require('datatables.net-buttons/js/buttons.print');
// require('datatables.net-select');


// $.DataTable = DataTable;

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0' + h : h = h) + '/' + (mesHoy < 10 ? mesHoy = '0' + mesHoy : mesHoy = mesHoy) + '/' + date.getFullYear();

var botones = [
    {
        extend: 'pageLength',
        text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        // titleAttr: 'Ver número de registros'
    },
    // {
    //     extend: 'copy',
    //     text: `<i style='font-size: 20px;' class='fal fa-copy'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     // titleAttr: 'Copiar al portapapeles',
    //     exportOptions: {
    //         columns: ':visible'
    //     }
    // }, 
    // {
    //     extend: 'csv',
    //     filename: hoy,
    //     text: `<i style='font-size: 20px;' class='fal fa-file-csv'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     title: hoy,
    //     // titleAttr: 'Exportar a csv',
    //     exportOptions: {
    //         columns: ':visible'
    //     }

    // },
    {
        extend: 'excel',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        title: hoy,
        // titleAttr: 'Exportar a excel',
        exportOptions: {
            columns: ':visible'
        }
    },
    {
        extend: 'pdf',
        filename: hoy,
        text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
        orientation: 'landscape',
        title: hoy,
        // titleAttr: 'Exportar a pdf',
        exportOptions: {
            columns: ':visible'
        }
    },
    // {
    //     extend: 'print',
    //     filename: hoy,
    //     text: `<i style='font-size: 20px;' class='fal fa-print'></i>`,
    //     className: 'btn btn-flat mr-1 btn-outline-secondary',
    //     title: hoy,
    //     // titleAttr: 'Imprimir',
    //     customize: function ( win ) {
    //         $(win.document.body)
    //             .css( 'font-size', '22pt' );

    //         $(win.document.body).find( 'table' )
    //             .addClass( 'compact' )
    //             .css( 'font-size', '14pt' );
    //     },
    //     exportOptions: {
    //         modifier: {
    //             selected: null
    //         }
    //     },
    //     exportOptions: {
    //         columns: ':visible'
    //     }
    // },
    {
        extend: 'colvis',
        text: `<i style='font-size: 20px;' class='fad fa-line-columns'></i>`,
        className: 'btn btn-flat mr-1 btn-outline-secondary',
    }
];

function DataTableInformes(props) {

    const cookies = new Cookies();

    const { appCryptCom, apiKey } = useContext(LoginContext);

    // ***** props *****
    const { id, data, columnas, confApp, appCryptComVar } = props;
    let { buttons, ordering, order, searching, paging, select, trad, traduction, pagelength } = props;
    const [loadingInforme, saveLoadingInforme] = useState(false);
    const [showFirmas, saveShowFirmas] = useState();
    const [tituloFirma, saveTituloFirma] = useState("");
    const [numFirmas, saveNumFirmas] = useState(0);
    const [dataAgentes, saveDataAgente] = useState([]);
    const [idDocFirma, saveIdDocFirma] = useState(0);
    const [idLinFirma, saveIdLinFirma] = useState(0);
    const [viewTextoLibreFirma, saveViewTextLibreFirma] = useState(true);
    const [viewFirmaSinAgente, saveViewFirmaSinAgente] = useState(true);
    const [btnFirma, saveBtnFirma] = useState(null);

    useEffect(() => {

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0, "asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        select === undefined ? select = false : select = select;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;

        columnas.map((columna, i) => {
            columna.createdCell = (td, cellData, rowData, row, col) => {
                let jsonValido = null;

                try {
                    // Reemplazamos comillas invertidas por comillas normales                                            
                    const limpio = cellData
                        .replace(/´/g, '"')   // comillas latinas
                        .replace(/`/g, '"')   // backticks
                        .replace(/'/g, '"');  // comillas simples → dobles

                    const jsonLimpio = JSON.parse(limpio);
                    // Botón informes
                    // Verificamos que tenga al menos la clave obligatoria
                    if (typeof jsonLimpio === 'object' && jsonLimpio !== null && 'idinforme' in jsonLimpio) {
                        jsonValido = {
                            idinforme: jsonLimpio.idinforme,
                            idreg: jsonLimpio.idreg ?? 0,
                            asunto: jsonLimpio.asunto ?? "",
                            cuerpo: jsonLimpio.cuerpo ?? "",
                            destinatarios: jsonLimpio.destinatarios ?? ""
                        };

                        let templateNecesario = ReactDOM.render(
                            <div id={"btnInf-" + row + "-" + col} className="btn btn-outline-primary" style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClick={e => executeInforme(jsonValido)}>
                                <i className="far fa-print mr-1" ></i>
                            </div>
                            , td);
                        $(td).addClass(rowData.style);
                        // $(td).html(templateNecesario)                                        
                    } else if (typeof jsonLimpio === 'object' && jsonLimpio !== null && 'numfirmas' in jsonLimpio) {
                        // Botón firmas                                              
                        jsonValido = {
                            titulo: jsonLimpio.titulo ?? '',
                            firmasinagente: jsonLimpio.firmasinagente ?? true,
                            textolibre: jsonLimpio.textolibre ?? true,
                            idlin: jsonLimpio.idlin ?? 0,
                            iddoc: jsonLimpio.iddoc ?? 0,
                            idsagentes: jsonLimpio.idsagentes ?? 0,
                            numfirmas: jsonLimpio.numfirmas ?? 1
                        };
                        let templateNecesario = ReactDOM.render(
                            <div id={"btnFirma-" + row + "-" + col} className="btn btn-outline-primary" style={{ display: "flex", justifyContent: "center", alignItems: "center" }} onClick={e => executeFirma(jsonValido, "btnFirma-" + row + "-" + col)}>
                                <i className="fal fa-file-signature mr-1" ></i>
                            </div>
                            , td);

                    }
                } catch (error) { }
            }
        })

        if (data) {
            if (data.length > 0) {
                if ($.fn.DataTable.isDataTable("." + id)) {
                    let oTable = $("." + id).DataTable();
                    oTable.clear();
                    for (let i = 0; i < data.length; i++) {
                        oTable.row.add(data[i]);
                    }
                    oTable.draw();
                } else {
                    $("." + id).DataTable({
                        mark: true,
                        dom: buttons,
                        data: data,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false,
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [10, 25, 50, 100],
                            ['10', '25', '50', '100']
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing": traduction.sprocessing.title,
                            "sLengthMenu": traduction.slengthmenu.title,
                            "sZeroRecords": traduction.szerorecords.title,
                            "sEmptyTable": traduction.semptytable.title,
                            "sInfo": traduction.sinfo.title,
                            "sInfoEmpty": traduction.sinfoempty.title,
                            "sInfoFiltered": traduction.sinfofiltered.title,
                            "sInfoPostFix": traduction.sinfopostfix.title,
                            "sSearch": traduction.ssearch.title,
                            "sUrl": traduction.surl.title,
                            "sInfoThousands": traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst": "<<",
                                "sLast": ">>",
                                "sNext": ">",
                                "sPrevious": "<"
                            },
                            "oAria": {
                                "sSortAscending": traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }
                        },
                        rowCallback: function (row, data, index) {
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                // if( item.outerText.includes("#") ){
                                if (item.outerText.startsWith("#") && item.outerText !== "##@##") {
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }
                        }
                    })
                }
            } else {
                if ($.fn.DataTable.isDataTable("." + id)) {
                    let oTable = $("." + id).DataTable();
                    oTable.clear();
                    oTable.draw();
                } {
                    $("." + id).DataTable({
                        mark: true,
                        dom: buttons,
                        data: null,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false,
                        autoWidth: false,
                        retrieve: true,
                        lengthMenu: [
                            [10, 25, 50, 100],
                            ['10', '25', '50', '100']
                        ],
                        deferRender: true,
                        language: {
                            "sProcessing": traduction.sprocessing.title,
                            "sLengthMenu": traduction.slengthmenu.title,
                            "sZeroRecords": traduction.szerorecords.title,
                            "sEmptyTable": traduction.semptytable.title,
                            "sInfo": traduction.sinfo.title,
                            "sInfoEmpty": traduction.sinfoempty.title,
                            "sInfoFiltered": traduction.sinfofiltered.title,
                            "sInfoPostFix": traduction.sinfopostfix.title,
                            "sSearch": traduction.ssearch.title,
                            "sUrl": traduction.surl.title,
                            "sInfoThousands": traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst": "<<",
                                "sLast": ">>",
                                "sNext": ">",
                                "sPrevious": "<"
                            },
                            "oAria": {
                                "sSortAscending": traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }
                        },
                        rowCallback: function (row, data, index) {
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                // if( item.outerText.includes("#") ){
                                if (item.outerText.startsWith("#") && item.outerText !== "##@##") {
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }


                        }
                    })
                }
            }
        } else {
            if ($.fn.DataTable.isDataTable("." + id)) {
                let oTable = $("." + id).DataTable();
                oTable.clear();
                oTable.draw();
            } {
                $("." + id).DataTable({
                    mark: true,
                    dom: buttons,
                    data: null,
                    columns: columnas,
                    ordering: ordering,
                    order: order,
                    searching: searching,
                    paging: paging,
                    select: select,
                    buttons: [botones],
                    // fixedHeader: true,
                    // scrollX: true,
                    responsive: false,
                    autoWidth: false,
                    retrieve: true,
                    lengthMenu: [
                        [10, 25, 50, 100],
                        ['10', '25', '50', '100']
                    ],
                    deferRender: true,
                    language: {
                        "sProcessing": traduction.sprocessing.title,
                        "sLengthMenu": traduction.slengthmenu.title,
                        "sZeroRecords": traduction.szerorecords.title,
                        "sEmptyTable": traduction.semptytable.title,
                        "sInfo": traduction.sinfo.title,
                        "sInfoEmpty": traduction.sinfoempty.title,
                        "sInfoFiltered": traduction.sinfofiltered.title,
                        "sInfoPostFix": traduction.sinfopostfix.title,
                        "sSearch": traduction.ssearch.title,
                        "sUrl": traduction.surl.title,
                        "sInfoThousands": traduction.sinfothousands.title,
                        "sLoadingRecords": traduction.sloadingrecords.title,
                        "oPaginate": {
                            "sFirst": "<<",
                            "sLast": ">>",
                            "sNext": ">",
                            "sPrevious": "<"
                        },
                        "oAria": {
                            "sSortAscending": traduction.ssortascending.title,
                            "sSortDescending": traduction.ssortdescending.title
                        },
                        select: {
                            rows: traduction.rows.title
                        },
                        buttons: {
                            copyTitle: traduction.copytitle.title,
                            copyKeys: traduction.copykeys.title,
                            copySuccess: {
                                _: traduction.copysuccess.many.title,
                                1: traduction.copysuccess.one.title
                            },
                        }
                    },
                    rowCallback: function (row, data, index) {
                        // Si algún td incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                        for (let item of row.children) {
                            // if( item.outerText.includes("#") ){
                            if (item.outerText.startsWith("#") && item.outerText !== "##@##") {
                                item.bgColor = item.outerText;
                                item.innerText = "";
                            }
                        }

                    }
                })
            }
        }

    }, [data])

    const executeInforme = async (json) => {
        saveLoadingInforme(true);
        // Ejemplo https://api.dev.aitodetec.com/reports/generarInforme?usuactual=789&sesion=abc123&idinf=123&idreg=456&asunto=Informe de prueba&cuerpo=<h1>Este es el cuerpo del informe</h1>&destinatarios=danielgarciaduran@gmail.com;dgdcontent@gmail.com        
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        let url = `/reports/generarInforme?usuactual=${getDecodedCookie('id')}&sesion=${getDecodedCookie('sesion')}&idinf=${json.idinforme}&idreg=${json.idreg}&asunto=${json.asunto}&cuerpo=${json.cuerpo}&destinatarios=${json.destinatarios}`;
        const respuesta = await axios.get(getApiUrl(window.location.origin) + url, { cancelToken: source.token });
        if (respuesta.data.url != "") {
            // Forzar descarga            
            window.open(respuesta.data.url, '_blank');
            // var forceDown = document.createElement('a');
            // forceDown.setAttribute('href',respuesta.data.url);
            // forceDown.setAttribute('download','');
            // document.body.appendChild(forceDown);
            // forceDown.click(); 
            // forceDown.remove();            
        }
        saveLoadingInforme(false);
        if (respuesta.data.resemailok != "") {
            // alertService.success(`<i class="fal fa-check-circle mr-1"></i>${respuesta.data.resemailok}`, {autoClose: true});
            swal("", `${respuesta.data.resemailok}`, "success");
        }
        if (respuesta.data.error != "") {
            // alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.error}`, {autoClose: true}); 
            swal("Error", `${respuesta.data.error}`, "error");
        }
        if (respuesta.data.resemailko != "") {
            // alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data.resemailko}`, {autoClose: true}); 
            swal("Error", `${respuesta.data.resemailko}`, "error");
        }

    }

    const executeFirma = async (json, divBoton) => {
        saveBtnFirma(divBoton);
        saveIdDocFirma(json.iddoc);
        saveIdLinFirma(json.idlin);
        saveTituloFirma(json.titulo);
        saveNumFirmas(json.numfirmas);
        saveViewTextLibreFirma(json.textolibre);
        saveViewFirmaSinAgente(json.firmasinagente);
        const res = await getOptionsCboHelper(confApp.visorinformes.controles.firma.idage.datatype, confApp.visorinformes.controles.firma.idage.data, appCryptComVar, apiKey, json.idsagentes);
        saveDataAgente(res);
        saveShowFirmas(true);
    }

    const disableButonFirma = () => {
        const btn = document.getElementById(btnFirma);
        if (btn) {
            btn.parentElement.innerHTML = `<div id="${btnFirma}" class="btn btn-outline-success" style="display: flex;justify-content: center;align-items: center;">
                                                <i class="far fa-check"></i>
                                            </div>`;

        }
    }

    // Código para evitar los acentos en las búsquedas
    function removeAccents(data) {
        if (data.normalize) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data + ' ' + data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }

        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;

    searchType.string = function (data) {
        return !data ?
            '' :
            typeof data === 'string' ?
                removeAccents(data) :
                data;
    };

    searchType.html = function (data) {
        return !data ?
            '' :
            typeof data === 'string' ?
                removeAccents(data.replace(/<.*?>/g, '')) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas

    return (
        <Fragment>
            {loadingInforme ?
                <div style={{ height: 50, marginTop: 5, marginBottom: 10, textAlign: "center" }} >
                    <Spinner animation="border" />
                </div>
                :
                null
            }
            <div style={{ overflowX: "auto" }}>
                <table id={id} className={id + " table table-sm table-bordered table-striped table-hover dataTable"} style={{ width: "100%" }}></table>
            </div>
            {
                showFirmas
                    ?
                    <Firma
                        // cabecera={cabecera}
                        cabecera={{ id: idDocFirma }}
                        // lineasFirmas={lineasFirmas}
                        // lineasFirmas={[{idlinea: idLineaCreada, id: idLineaCreada, num1: 0}]}
                        lineasFirmas={[{ linea: { idlinea: idLinFirma, id: idLinFirma, nom1: tituloFirma } }]}
                        controles={confApp.visorinformes.controles}
                        show={showFirmas}
                        saveShow={saveShowFirmas}
                        traduction={trad.firma}
                        functionAfter={disableButonFirma}
                        // crewList={true}
                        numFirmasProp={numFirmas}
                        rangoAgentesProp={1}
                        dataAgentes={dataAgentes}
                        // defaultFirmante={agente}
                        cancelable={true}
                        viewTextoLibre={viewTextoLibreFirma}
                        viewFirmaSinAgente={viewFirmaSinAgente}
                    />
                    :
                    null
            }

        </Fragment>
    )
}

export default DataTableInformes;